// @flow
import styles from './MoreOptions.less';

import React from 'react';
import { connect } from 'react-redux';

import { ChevronIcon } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

type Props = {
  query: SearchParams
};

const mapStateToProps = ({ search }) => ({
  query: search.query
});

const MoreOptions = ({ query }: Props) => (
  <div className={styles.root}>
    <NavLink
      className={styles.link}
      location={{
        pathname: '/jobs',
        query,
        state: {
          moreOptions: true
        }
      }}
      data-automation="moreOptionsLink"
      rel="nofollow"
      analytics="more-options-clicked"
    >
      <span className={styles.label}>
        <span className={styles.labelOutline} />
        More options
      </span>
      <ChevronIcon direction="down" small />
    </NavLink>
  </div>
);

export default connect(mapStateToProps)(MoreOptions);
